module.exports = __webpack_public_path__ + "img/3.ce22b5e1.png";